import { createSelector } from '@ngrx/store';
import { getAppState } from 'apps/check-in-kiosk/src/app/reducers';

export interface CheckOutState {
  loading: boolean;
}

export const getCheckOutState = createSelector(
  getAppState,
  (app: any): CheckOutState => ({ loading: app.loading })
);

export const getCheckOutWorkflowId = createSelector(
  getAppState,
  ({ workflow_id }: any) => workflow_id
);
